import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { KeyRound } from "lucide-react";
import { http, errMsg } from "@/lib/api";
import { AuthShell, authInput } from "@/pages/ForgotPassword";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) return setError("Kata sandi minimal 8 karakter.");
    if (pw !== pw2) return setError("Konfirmasi kata sandi tidak sama.");
    setBusy(true);
    setError("");
    try {
      await http.post("/auth/reset-password", { token, new_password: pw });
      setDone(true);
    } catch (err) { setError(errMsg(err)); } finally { setBusy(false); }
  };
  if (!token) {
    return <AuthShell title="Tautan tidak valid" subtitle="Tautan reset tidak lengkap. Silakan minta tautan baru." testId="reset-password-page"><Link to="/admin/forgot-password" className="mt-5 block text-center text-sm font-semibold text-nanina-green underline" data-testid="reset-request-new-link">Minta tautan baru</Link></AuthShell>;
  }
  return (
    <AuthShell title="Buat Kata Sandi Baru" subtitle="Gunakan minimal 8 karakter. Tautan hanya dapat dipakai satu kali." testId="reset-password-page">
      {done ? (
        <div className="mt-5" data-testid="reset-password-success">
          <p className="rounded-xl bg-nanina-freshsoft p-3 text-xs text-nanina-green">Kata sandi berhasil diperbarui. Semua sesi lama telah dikeluarkan.</p>
          <Link to="/admin/login" className="mt-4 block w-full text-center rounded-full bg-nanina-green text-white text-sm font-semibold py-3" data-testid="reset-go-login-button">Masuk dengan kata sandi baru</Link>
        </div>
      ) : (
        <form onSubmit={submit} data-testid="reset-password-form">
          <label className="mt-5 block text-xs font-semibold text-nanina-green">Kata sandi baru
            <input type="password" required minLength={8} value={pw} onChange={(e) => setPw(e.target.value)} autoComplete="new-password" className={authInput} data-testid="reset-password-input" />
          </label>
          <label className="mt-3 block text-xs font-semibold text-nanina-green">Ulangi kata sandi baru
            <input type="password" required minLength={8} value={pw2} onChange={(e) => setPw2(e.target.value)} autoComplete="new-password" className={authInput} data-testid="reset-password-confirm-input" />
          </label>
          {error && <p className="mt-3 text-xs text-red-600" role="alert" data-testid="reset-password-error">{error}</p>}
          <button disabled={busy} className="mt-5 w-full inline-flex justify-center items-center gap-2 rounded-full bg-nanina-green text-white text-sm font-semibold py-3 disabled:opacity-60" data-testid="reset-password-submit-button">
            <KeyRound className="h-4 w-4" /> {busy ? "Menyimpan..." : "Simpan kata sandi"}
          </button>
        </form>
      )}
    </AuthShell>
  );
}
